// plugins/d3-delaunay.client.js
import Vue from 'vue';

if (process.client) {
  const { Delaunay } = require('d3-delaunay');
  Vue.prototype.$delaunay = Delaunay;
}
